import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  buttonLabels: {
    adminUserView: "",
    createButton: "",
    updateButton: ""
  },
  titles: {
    /**create page */
    createNewAdminUser: "",
    searchActiveUserDetails: "",
    adminUserDetails: "",
    adminUserRoles: "",
    userProfileSection: "",
    cronofySection: ""
  },
  fieldLables: {
    serach: {
      searchEmailId: ""
    },
    adminUserDetails: {
      firstName: "",
      lastName: "",
      email: "",
      preferredName: "",
      preferredNo: "",
      AffiliatedEmail: "",
      timezone: "",
      country: "",
      appLang: "",
      serviceOff: "",
      status: ""
    },
    adminUserRoles: {
      enterpriseAdmin: "",
      clientPortalRole: "",
      candidatePortalRole: "",
      country: "",
      serviceOff: "",
    },
    userProfile: {
      bio: "",
      expertise: "",
      linkedInId: "",
      tweeterId: "",
      lang: ""
    },
    cronofy: {
      timezone: "",
      serviceAccName: "",
      availableDays: "",
      workingStartHr: "",
      workingEndHr: ""
    }
  }
};

const adminUserSectionStaticContentSlice = createSlice({
  name: "adminUserSectionStaticContentSlice",
  initialState,
  reducers: {
    saveAdminUserSectionStaticContent: (state, action) => {
      const { payload } = action;

      // Helper to assign nested fields with fallback
      function assignFields(target, source, defaults) {
        Object.entries(defaults).forEach(([key, def]) => {
          target[key] = source?.[key] ?? def;
        });
      }

      assignFields(state.buttonLabels, payload?.buttonLabels, {
        adminUserView: "Admin Users",
        createButton: "Create admin user",
        updateButton: "Update admin user",
      });

      assignFields(state.titles, payload?.titles, {
        createNewAdminUser: "Create New Admin User",
        searchActiveUserDetails: "Search Active User Details",
        adminUserDetails: "Admin User Details",
        adminUserRoles: "Admin User Roles",
        userProfileSection: "User Profile Section",
        cronofySection: "Cronofy Section",
      });

      assignFields(state.fieldLables.serach, payload?.fieldLables?.serach, {
        searchEmailId: "Search Email Id",
      });

      assignFields(state.fieldLables.adminUserDetails, payload?.fieldLables?.adminUserDetails, {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        preferredName: "Preferred Name",
        preferredNo: "Preferred Number",
        AffiliatedEmail: "Affiliat Email Address",
        timezone: "Time Zone",
        country: "Country",
        appLang: "Application Language",
        serviceOff: "Service Office",
        status: "Status",
      });

      assignFields(state.fieldLables.adminUserRoles, payload?.fieldLables?.adminUserRoles, {
        enterpriseAdmin: "Enterprise Admin",
        clientPortalRole: "Client Portal Role",
        candidatePortalRole: "Candidate Portal Role",
        country: "Country",
        serviceOff: "Service Office",
      });

      assignFields(state.fieldLables.userProfile, payload?.fieldLables?.userProfile, {
        bio: "Bio",
        expertise: "Expertise",
        linkedInId: "LinkedIn Id",
        tweeterId: "Tweeter Id",
        lang: "Language",
      });

      assignFields(state.fieldLables.cronofy, payload?.fieldLables?.cronofy, {
        timezone: "Time Zone",
        serviceAccName: "Service Account Name",
        availableDays: "Available Days",
        workingStartHr: "Working Hours (Start time)",
        workingEndHr: "Working Hours (End time)",
      });
    },
  }
});

export const { saveAdminUserSectionStaticContent } = adminUserSectionStaticContentSlice.actions;

export default adminUserSectionStaticContentSlice.reducer;
